import React from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import { renderMoney, TimeStream } from '../../utils'
import { Page, WKTab } from '../../components'
import { WKSearch, WKVisible, WKInfiniteScroll } from '../../components/wk'
import MediaItem from './MediaItem'
import { Flex, FlexItem, Dialog } from 'react-weui'
import ResellNoItem from './ResellNoItem'
import '../../css/page/ResellPage.css'
import questionImg from '../../images/question.png'


class ResellOrder extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            orders: [],
            isPending: false,
            hasMore: true,
            offset: 0,
            total_count: '',
            total_earn: 0,
            isShowQuestionModal: false,
        }
    }
    componentDidMount() {
        this.fetchData()
    }
    fetchData() {
        this.setState({ isPending: true })
        axios.get('/api/resell/my/invoices', {
            params: {
                offset: this.state.offset
            }
        })
            .then(res => {
                const data = res.data.data
                this.setState({
                    isPending: false,
                    offset: data.next_offset,
                    hasMore: data.has_more,
                    orders: this.state.orders.concat(data.invoices),
                    total_count: data.total_count,
                    total_earn: data.total_earn,
                })
            })
    }
    getSceneName (scene) {
        switch (scene) {
            case 'pay_channel_resell1':
                return '专栏佣金流水'
            case 'pay_channel_resell':
                return '专栏邀请奖励'
            case 'pay_lecture_resell1':
                return '课程佣金流水'
            case 'pay_lecture_resell':
                return '课程邀请奖励'
            case 'liveroom_vip_resell':
                return 'VIP会员邀请奖励'
            case 'liveroom_vip_resell1':
                return 'VIP会员佣金'
            default:
                return '其他'
        }
    }
    getMoneyField (item) {
        if (item.scene === 'pay_channel_resell1' || item.scene === 'pay_lecture_resell1') {
            return '佣金'
        } else {
            return '邀请奖励'
        }
    }
    getNicknameField (item) {
        if (item.seller.id === this.props.account.id) {
            return '订购人'
        } else {
            return '邀请人'
        }
    }
    getNickname (item) {
        return item.seller.id === this.props.account.id ? item.payer.nickname : item.seller.nickname
    }
    render() {
        const { orders } = this.state
        return (
            <div className="resell-order-page wk-page">
                <div className='order-list'>
                    <ResellNoItem 
                        show={this.state.total_count === 0}
                        text='暂无分销成功的订单，继续努力吧'
                    />
                    <WKVisible create={orders.length > 0}>
                        <div className="title wk-border-line-after wk-position-rlt">
                            <span className='margin-right'>订单：{this.state.total_count}个</span>
                            <span className='yellow'>累计收益：¥{renderMoney(this.state.total_earn)}</span>
                        </div>
                    </WKVisible>
                    {
                        orders.length > 0 && (
                            orders.map(item => (
                                <div className="order-item" key={item.id}>
                                    <Flex>
                                        <FlexItem>订单编号</FlexItem>
                                        <FlexItem>{item.id}</FlexItem>
                                    </Flex>
                                    <Flex>
                                        <FlexItem>订单时间</FlexItem>
                                        <FlexItem>{TimeStream(item.create_timestamp)}</FlexItem>
                                    </Flex>
                                    <Flex>
                                        <FlexItem>直播间</FlexItem>
                                        <FlexItem>{item.liveroom_name}</FlexItem>
                                    </Flex>
                                    <Flex>
                                        <FlexItem>商品</FlexItem>
                                        <FlexItem className='weui-flex__item scene-field'>{item.desc}</FlexItem>
                                    </Flex>
                                    {item.seller &&
                                    <Flex>
                                        <FlexItem>{this.getNicknameField(item)}</FlexItem>
                                        <FlexItem>{this.getNickname(item)}</FlexItem>
                                    </Flex>
                                    }
                                    <Flex>
                                        <FlexItem>成单价格</FlexItem>
                                        <FlexItem>￥{renderMoney(item.fee)}</FlexItem>
                                    </Flex>
                                    <Flex>
                                        <FlexItem>{this.getMoneyField(item)}</FlexItem>
                                        <FlexItem>{item.percent}% (￥{renderMoney(item.earn)})</FlexItem>
                                    </Flex>
                                </div>
                            ))
                        )
                    }
                    <WKInfiniteScroll 
                        onTouchBottom={() => this.fetchData()} 
                        isStop={this.state.isPending} 
                        isKill={!this.state.hasMore}
                        isShowLoading={true}
                    />
                </div>
            </div>
            
        )
    }
}

export default connect(state => ({
    account: state.account,
    selectId: state.component.wkTab.selectId,
}))(ResellOrder)


// WEBPACK FOOTER //
// ./src/pages/resell/ResellOrderPage.js